import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownMapping from 'lumen/components/settings/central-mapping/dropdowns/dropdown-mapping';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { CentralMappingCategory } from 'lumen/models';

interface MarketSettingsCentralMappingTablesCellsTdMappingSignature {
  Args: {
    column: {
      hierarchyCategories: CentralMappingCategory[];
      isReadOnly?: boolean;
    };
    row: {
      autoCategory: CentralMappingCategory;
      category: CentralMappingCategory;
      isMixedCategory: boolean;
      isParent?: boolean;
      onOverrideAutomapping?: () => void;
      setCategory: (category: CentralMappingCategory | null) => void;
      toggleAutomapping: (category: CentralMappingCategory | null) => void;
      userCategory: CentralMappingCategory;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const MarketSettingsCentralMappingTablesCellsTdMapping: TOC<MarketSettingsCentralMappingTablesCellsTdMappingSignature> =
  <template>
    <div
      data-test-id={{if
        @row.isParent
        "table-central-mapping-parent-td-mapping"
        "table-central-mapping-td-mapping"
      }}
    >
      <SettingsCentralMappingDropdownsDropdownMapping
        @autoCategory={{@row.autoCategory}}
        @category={{@row.category}}
        @hierarchyCategories={{@column.hierarchyCategories}}
        @isMixed={{@row.isMixedCategory}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @onOverrideAutomapping={{@row.onOverrideAutomapping}}
        @setCategory={{@row.setCategory}}
        @toggleAutomapping={{@row.toggleAutomapping}}
        @userCategory={{@row.userCategory}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default MarketSettingsCentralMappingTablesCellsTdMapping;
